// Combined Transaction Service - GraphQL operations for Combined Transactions (Deposits + Withdrawals)
import { graphqlClient } from '../graphqlClient';

// ==================== Reseller Combined Transactions ====================

export const getResellerCombinedTransactions = async () => {
  const query = `
    query GetResellerCombinedTransactions {
      resellerCombinedTransactions {
        id
        reference_id
        merchant_ref
        type
        status
        amount
        fee_amount
        net_amount
        total_fee
        currency
        payment_method
        provider_code
        provider_ref
        merchant_id
        merchant_code
        merchant_name
        reseller_id
        reseller_code
        reseller_name
        customer_id
        customer_name
        customer_email
        customer_phone
        bank_code
        bank_account
        error_message
        created_date
        processed_at
      }
    }
  `;

  const result = await graphqlClient.query(query);
  return result.resellerCombinedTransactions || [];
};

export const getCombinedQRCodeAndWitData = async (page = 1, limit = 10, search = "", filters = null, merchants = null) => {
  const query = `
    query MerchantQRCodesAndTransactions($page: Int, $limit: Int, $search: String, $filters: PaginationFilterInput, $merchants: [String]) {
      merchantQRCodesAndTransactions(page: $page, limit: $limit, search: $search, filters: $filters, merchants: $merchants) {
        data {
          id
          transaction_id
          reference_id
          merchant_ref
          type
          status
          amount
          fee_amount
          net_amount
          total_fee
          currency
          payment_method
          provider_code
          provider_ref
          merchant_id
          merchant_code
          merchant_name
          reseller_id
          reseller_code
          reseller_name
          customer_id
          customer_name
          customer_email
          customer_phone
          bank_name
          bank_code
          bank_account
          error_message
          created_date
          processed_at
        }
        total
        page
        limit
        totalPages
      }
    }
  `;

  const variables = {
    page,
    limit,
    search: search || undefined,
    filters: filters || undefined,
    merchants: merchants || undefined,
  };

  const result = await graphqlClient.query(query, variables);
  return result.merchantQRCodesAndTransactions || { data: [], total: 0, page: 1, limit: 10, totalPages: 0 };
};

export const getAllProvider = async () => {
  const query = `
    query GetAllProvider {
      getAllProvider
    }
  `;

  const result = await graphqlClient.query(query);
  return result.getAllProvider || [];
};